import { assert_true } from '@shared/asserts/utils_asserts';
import { cloneDeep } from 'es-toolkit';
import { FIELD__base } from '../../_fields/_base/FIELD__base';

export function FN_FIELD__apply_init_options(field: FIELD__base, options: any) {
  for (let [key, value_options] of Object.entries(options)) {
    let value_field = (field as any)[key];
    assert_true(key in field);

    if (value_field instanceof FIELD__base) {
      FN_FIELD__apply_init_options(value_field, value_options);
    } else if (Array.isArray(value_field)) {
      (field as any)[key] = cloneDeep(value_options);
    } else {
      (field as any)[key] = cloneDeep(value_options);
    }
  }
}
